import './form.css'

export const FieldSkeleton = ({ count = 1 }) =>
  Array.from({ length: count }).map((_, i) => (
    <div className="ff-grid__item" key={`ff-skeleton-${i}`} aria-hidden="true">
      <div className="ff-skeleton ff-skeleton--label" />
      <div className="ff-skeleton ff-skeleton--input" />
    </div>
  ))
